var render = function render(){var _vm=this,_c=_vm._self._c;return _c('taskyType',{attrs:{"type":4}})
}
var staticRenderFns = []

export { render, staticRenderFns }